var CustomSnackBarModule = /** @class */ (function () {
    function CustomSnackBarModule() {
    }
    return CustomSnackBarModule;
}());
export { CustomSnackBarModule };
